import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Mask({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Mask</title>
      <path
        d="M11.3424 18.8904L11.4657 18.1506L11.3424 18.8904ZM12.6576 18.8904L12.5343 18.1506L12.6576 18.8904ZM9.3424 18.5571L9.2191 19.2969L9.3424 18.5571ZM5.25 10.2361V14.6115H6.75V10.2361H5.25ZM18.75 14.6115V10.2361H17.25V14.6115H18.75ZM17.2298 7.77639L13.2298 5.77639L12.559 7.11803L16.559 9.11803L17.2298 7.77639ZM10.7702 5.77639L6.77016 7.77639L7.44098 9.11803L11.441 7.11803L10.7702 5.77639ZM9.2191 19.2969L11.2191 19.6302L11.4657 18.1506L9.4657 17.8173L9.2191 19.2969ZM12.7809 19.6302L14.7809 19.2969L14.5343 17.8173L12.5343 18.1506L12.7809 19.6302ZM11.2191 19.6302C11.7361 19.7164 12.2639 19.7164 12.7809 19.6302L12.5343 18.1506C12.1805 18.2096 11.8195 18.2096 11.4657 18.1506L11.2191 19.6302ZM13.2298 5.77639C12.4556 5.38929 11.5444 5.38929 10.7702 5.77639L11.441 7.11803C11.7929 6.94208 12.2071 6.94208 12.559 7.11803L13.2298 5.77639ZM18.75 10.2361C18.75 9.19444 18.1615 8.24222 17.2298 7.77639L16.559 9.11803C16.9825 9.32977 17.25 9.7626 17.25 10.2361H18.75ZM17.25 14.6115C17.25 16.2002 16.1014 17.5561 14.5343 17.8173L14.7809 19.2969C17.0713 18.9151 18.75 16.9335 18.75 14.6115H17.25ZM5.25 14.6115C5.25 16.9335 6.92871 18.9151 9.2191 19.2969L9.4657 17.8173C7.89859 17.5561 6.75 16.2002 6.75 14.6115H5.25ZM6.75 10.2361C6.75 9.7626 7.0175 9.32977 7.44098 9.11803L6.77016 7.77639C5.83851 8.24222 5.25 9.19445 5.25 10.2361H6.75Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M6 9V9C4.52412 8.50804 3 9.60656 3 11.1623V11.6082C3 12.4777 3.43457 13.2897 4.15806 13.772L6 15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 9V9C19.4759 8.50804 21 9.60656 21 11.1623V11.6082C21 12.4777 20.5654 13.2897 19.8419 13.772L18 15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12L11.3675 11.2108C11.7781 11.074 12.2219 11.074 12.6325 11.2108L15 12"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15L11.5149 14.6213C11.8334 14.5416 12.1666 14.5416 12.4851 14.6213L14 15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
